define("shared/components/shared/ui/navigation-arrows", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.NavigableTypes = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <a
    class="qa--searchProfile_prev_btn {{if this.showLeftArrow '' 'u--hide'}}"
    role="button"
    {{on "click" (fn @navigate false)}}
  >
    {{svg-jar
      "nav-left"
      class=(concat "o--icon cTD--navigationArrow--prev" (if this.needsNarrowArrows " is--narrow" ""))
    }}
  </a>
  <a
    class="qa--searchProfile_nxt_btn {{if this.showRightArrow '' 'u--hide'}}"
    role="button"
    {{on "click" (fn @navigate true)}}
  >
    {{svg-jar
      "nav-right"
      class=(concat "o--icon cTD--navigationArrow--next" (if this.needsNarrowArrows " is--narrow" ""))
    }}
  </a>
  */
  {
    "id": "jHFKPZLH",
    "block": "[[[11,3],[16,0,[29,[\"qa--searchProfile_prev_btn \",[52,[30,0,[\"showLeftArrow\"]],\"\",\"u--hide\"]]]],[24,\"role\",\"button\"],[4,[38,1],[\"click\",[28,[37,2],[[30,1],false],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,3],[\"nav-left\"],[[\"class\"],[[28,[37,4],[\"o--icon cTD--navigationArrow--prev\",[52,[30,0,[\"needsNarrowArrows\"]],\" is--narrow\",\"\"]],null]]]]],[1,\"\\n\"],[13],[1,\"\\n\"],[11,3],[16,0,[29,[\"qa--searchProfile_nxt_btn \",[52,[30,0,[\"showRightArrow\"]],\"\",\"u--hide\"]]]],[24,\"role\",\"button\"],[4,[38,1],[\"click\",[28,[37,2],[[30,1],true],null]],null],[12],[1,\"\\n  \"],[1,[28,[35,3],[\"nav-right\"],[[\"class\"],[[28,[37,4],[\"o--icon cTD--navigationArrow--next\",[52,[30,0,[\"needsNarrowArrows\"]],\" is--narrow\",\"\"]],null]]]]],[1,\"\\n\"],[13]],[\"@navigate\"],false,[\"if\",\"on\",\"fn\",\"svg-jar\",\"concat\"]]",
    "moduleName": "shared/components/shared/ui/navigation-arrows.hbs",
    "isStrictMode": false
  });
  let NavigableTypes = _exports.NavigableTypes = /*#__PURE__*/function (NavigableTypes) {
    NavigableTypes["Media"] = "media";
    NavigableTypes["Post"] = "post";
    return NavigableTypes;
  }({});
  let NavigationArrowsComponent = _exports.default = (_class = class NavigationArrowsComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "mediaNavigation", _descriptor, this);
      _initializerDefineProperty(this, "postNavigation", _descriptor2, this);
      _initializerDefineProperty(this, "secondaryModal", _descriptor3, this);
    }
    get navigationService() {
      return this.args.navigationModel === NavigableTypes.Media ? this.mediaNavigation : this.postNavigation;
    }
    get needsNarrowArrows() {
      return this.navigationService.needsNarrowArrows;
    }
    get showLeftArrow() {
      if (this.secondaryModal?.isModalOpen()) {
        return false;
      }
      return !this.navigationService.firstNavigableItem;
    }
    get showRightArrow() {
      if (this.secondaryModal?.isModalOpen()) {
        return false;
      }
      return !this.navigationService.lastNavigableItem;
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "mediaNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "postNavigation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "secondaryModal", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, NavigationArrowsComponent);
});